import enMessages from './en.json'
import esMessages from './es.json'
import frMessages from './fr.json'

import enMessagesCanada from './overrides/canada/en.json'
import esMessagesCanada from './overrides/canada/es.json'
import frMessagesCanada from './overrides/canada/fr.json'

export const CANADA_DOMAIN = '.ca'
export const USA = 'USA'
export const CANADA = 'CANADA'

const localeMappingUSA = {
  en: {
    locale: 'en-US',
    messages: enMessages
  },
  es: {
    locale: 'es-US',
    messages: esMessages
  },
  fr: {
    locale: 'fr-CA',
    messages: frMessages
  }
}

const localeMappingCanada = {
  en: {
    locale: 'en-CA',
    messages: {...enMessages, ...enMessagesCanada}
  },
  es: {
    locale: 'es-US',
    messages: {...esMessages, ...esMessagesCanada}
  },
  fr: {
    locale: 'fr-CA',
    messages: {...frMessages, ...frMessagesCanada}
  }
}

const localeMapping = {
  [USA]: localeMappingUSA,
  [CANADA]: localeMappingCanada
}

export default localeMapping
